export enum bahai_ethnicity {
  HispanicorLatino = 200630000,
  MiddleEastern = 200630001,
  Persian = 200630002,
  OtherEthnicity = 200630003,
}

export enum bahai_availability {
  Away = 200630001,
  Here = 200630000,
}

export enum bahai_fluentlanguagecode {
  OtherLanguage = 200630014,
}

export enum bahai_contactmethodcode {
  Phone = 200630000,
  Email = 200630001,
  Mail = 200630002,
  Text = 200630003,
  HomeVisit = 200630004,
  VideoConference = 200630005,
}

export enum UserRoles {
  RegionalSeekerResponseCoordinator = 200630000,
  SubRegionalSeekerResponseCoordinator = 200630001,
  ClusterGroupSeekerResponseCoordinator = 200630012,
  ClusterSeekerResponseCoordinator = 200630002,
  LocalitySeekerResponseCoordinator = 200630003,
  CommunityAdministrationTeamMember = 200630004,
  AssemblyDevelopmentTeamMember = 200630005,
  MembershipTeamMember = 200630006,
  NSASecretariatTeamMember = 200630007,
  NationalInquiryServicesTeamMember = 200630008,
  NationalITAdministrator = 200630009,
  NationalInquiryServicesAdministrator = 200630010,
  NationalSupportITAdministrator = 200630011,
}
